import { createSelector } from 'reselect';

import { AppState } from '../../types';

export const selectPromotionCodeList = (state: AppState) => state.promotionCodes.list;

export const selectPromotionCode = (state: AppState) => state.promotionCodes.selected;

export const selectVerifiedCode = (state: AppState) => state.promotionCodes.verification;

export const selectUpdatePlanPromotionCode = (state: AppState) => state.promotionCodes.updatePlanPromotionCode;

export const isPromotionCodePersistent = createSelector(
  selectPromotionCode,
  (state) => Boolean(state.data?.id),
);
